// @core/stores/subscription/SubscriptionAnalyticStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { subscriptionApi } from '@core/api';
import type {
  GetSubscriptionAnalyticsResponse,
} from '@core/types/subscription';

class SubscriptionAnalyticStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get subscription analytics
   */
  async GetSubscriptionAnalytics(params?: { granularity?: string | number | boolean; period_end?: string | number | boolean; period_start?: string | number | boolean; tenant_id?: string | number | boolean; }): Promise<GetSubscriptionAnalyticsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await subscriptionApi.GetSubscriptionAnalytics(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const subscriptionAnalyticStore = new SubscriptionAnalyticStore();
